import { GTMService, GTMServiceDev, GTMServiceProd } from './googleTagManager.service';
import { Inject, Injectable, Injector } from '@angular/core';
import { APP_CONFIG, AppConfig } from '../config-initialization.service';


//Factory to initialize the service based on the environment
@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
    public Prod: boolean;
    public Uat: boolean;

    constructor(@Inject(APP_CONFIG) private config: AppConfig,) {
      this.Prod = this.config.production;
      this.Uat = this.config.uat;
    }
}

// TagManagerService factory - Responsible to instantiate the service
let tagManagerServiceFactory = (envService: EnvironmentService, injector: Injector) => {
  return new GTMServiceProd(injector);
};

// Provider - Used in the Component
export let TagManagerServiceProvider = { 
  provide: GTMService,
  useFactory: tagManagerServiceFactory,
  deps: [EnvironmentService, Injector]
};